import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { PieChartComponent } from './types/pie-chart.component.js';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { NgxPieChartZeroMarginDirective } from './fix/pie-chart-margin-fix.directive.js';
import { LineChartComponent } from './types/line-chart.component.js';
import { MessagesModule } from '../messages/messages.module.js';

@NgModule({
	declarations: [PieChartComponent, LineChartComponent, NgxPieChartZeroMarginDirective],
	exports: [PieChartComponent, LineChartComponent],
	imports: [CommonModule, NgxChartsModule, MessagesModule]
})
export class GraphsModule {}
